import { mainDivId } from "../helpers/constants";
import { injectCss } from "../helpers/assets";

export function hideMapSkeleton() {
    const skeletonEl = document.getElementsByClassName("skeleton-map")[0];
    if (skeletonEl) skeletonEl.style.display = "none";
}

export function addMapSkeleton() {
    let style = ".skeleton-map {animation: skeletonAnim 0.8s linear infinite alternate;";
    style += "-webkit-backface-visibility: hidden;";
    style += "backface-visibility: hidden;";
    style += "will-change: opacity;";
    style += "position: relative;";
    style += "width: 100%;}.skeleton-map::after {";
    style += "content: '';";
    style += "position: absolute;";
    style += "top: 0;";
    style += "right: 0;";
    style += "bottom: 0;";
    style += "left: 0;";
    style += "display: block;";
    style += "background-color: #e7e8ea;";
    style += "}";
    style += "@keyframes skeletonAnim {from {opacity: 0.45;}to {opacity: 0.9;}}";
    injectCss(style);
    let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
    if (!vh) vh = 500;
    const loaderHtml = `<div class='skeleton-map' style='height:${vh}px; display:block;'></div>`;
    document.getElementById(mainDivId).innerHTML = loaderHtml;
  }